// QueryType.js
import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';

const QueryType = ({ 
  query_type, 
  query_type_verbose, 
  size = 'small',
  sx = {}
}) => {
  // Query type configuration with colors - customer queries only
  const getQueryTypeColor = (queryType) => {
    const colors = {
      // Customer Query Types
      'Upgrade': '#007bff', // Primary - Blue
      'User Slots': '#28a745', // Success - Green
      'Credits': '#ffc107', // Warning - Orange
      'Renew': '#17a2b8', // Info - Blue
      'Other': '#6c757d', // Secondary - Gray
    };
    return colors[queryType] || '#6c757d'; // Default gray for unknown type
  };

  const queryTypeColor = getQueryTypeColor(query_type_verbose || query_type);

  return (
    <Box 
      sx={{ 
        display: 'inline-block',
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        backgroundColor: `${queryTypeColor}20`, // 20% opacity background
        border: `1px solid ${queryTypeColor}`,
        ...sx
      }}
    >
      <Typography 
        variant={size === 'small' ? 'body2' : 'body1'}
        sx={{ 
          fontWeight: 600,
          fontSize: size === 'small' ? '0.75rem' : '0.875rem',
          color: queryTypeColor,
          textAlign: 'center'
        }}
      >
        {query_type_verbose || query_type || 'General'}
      </Typography>
    </Box>
  );
};

export default QueryType;
